/** URL absoluta do player para abrir na TV Box. */
export function playerScreenUrl(telaId: string): string {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/player/${telaId}`;
}
